<template>
  <div v-if="(desistencias && desistencias.length > 0) && !desistenciasLoading" class="wrapper-sm no-padder m-b">
    <email-view ref="emailView" />
    <div class=" bg-black">
      <div class="wrapper-sm bg-dark font-bold text-uppercase">Desistências</div>
      <div class="">
        <table class="table table-black" id="tableLances" >
          <thead>
          <tr>
            <th>Data</th>
            <th>Apelido</th>
            <th>Valor</th>
            <th>Lote</th>
            <th>Status</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="venda in desistencias">
            <td>{{ moment(venda.data.date).format('L') }} {{ moment(venda.data.date).format('LTS') }}</td>
            <td>
              <router-link target="_blank"
                           :to="{name: 'arrematantes.visualizar', params: {id: venda.arrematante.id}}">{{
                venda.arrematante.apelido }}
              </router-link>
            </td>
            <td>R$ {{venda.dados.lote.valorArremate|moeda}}</td>
            <td>
              <router-link target="_blank"
                           :to="{name: 'lotes.visualizar', params: {id: venda.dados.lote.id}}">{{
                venda.dados.lote.numero }}
              </router-link>
              <span v-if="venda.dados.lote.leilao">do leilão de {{ moment(venda.dados.lote.leilao.dataAbertura.date).format('L LTS') }}</span>
            </td>
            <td>
              <div v-if="venda.status === 1">Aviso registro órgãos de proteção</div>
              <div v-else-if="venda.status === 2">Dívida inscrita</div>
              <div v-else-if="venda.status === 100">Dívida paga</div>
              <div v-else-if="venda.status === 101"> Dívida cancelada</div>
              <div v-else>Cobrança de multa</div>
            </td>
            <td>
              <a class="btn btn-xs bg-white" @click="cobrarDesistencia(venda.id)">Cobrar</a>
              <a class="btn btn-xs btn-warning" @click="informarNegativacao(venda.id)">Alerta Negativação</a>
              <a class="btn btn-xs btn-danger" @click="negativar(venda.id)">Negativar</a>
              <a class="btn btn-xs btn-success" @click="informarNegativacao(venda.id)">Pagar</a>
              <a class="btn btn-xs btn-info" @click="informarNegativacao(venda.id)">Cancelar</a>
            </td>
          </tr>
          <tr v-if="(!desistencias || desistencias.length === 0) && !desistenciasLoading">
            <td colspan="4" class="no-borders" style="border-bottom: none"><span
              class="text-danger">Nenhuma desistência</span>
            </td>
          </tr>
          <tr v-if="desistenciasLoading">
            <td colspan="4" class="no-borders text-center" style="border-bottom: none"><i
              class="fa fa-spin fa-spinner m-t fa-2x"></i></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
  <div v-else>
    <div v-if="desistenciasLoading">Verficando se há desistências...</div>
    <div v-else></div>
  </div>
</template>

<script>
import service from '../../../../../domain/leiloes/services'
import EmailView from './EmailView'

export default {
  name: 'Desistencias',
  components: {EmailView},
  props: ['lote', 'arrematante'],
  data () {
    return {
      desistenciasLoading: false,
      desistencias: []
    }
  },
  mounted () {
    if (this.lote) {
      this.desistenciasLoading = true
      service.carregaDesistenciasLote(this.lote)
        .then(({data}) => {
          this.desistencias = data
          this.desistenciasLoading = false
        })
        .catch(error => {
          this.desistenciasLoading = false
          // alert('Impossível verificar a existência de desistências.')
          console.log(error)
        })
      return
    }
    this.desistenciasLoading = true
    service.carregaDesistenciasArrematante(this.arrematante)
      .then(({data}) => {
        this.desistencias = data
        this.desistenciasLoading = false
      })
      .catch(error => {
        this.desistenciasLoading = false
        // alert('Impossível verificar a existência de desistências.')
        console.log(error)
      })
  },
  methods: {
    cobrarDesistencia (desistencia) {
      this.$refs.emailView.open(
        function () {
          service.gerarEmailDesistencia(desistencia)
            .then((response) => {
              this.bindLoad(response)
              console.log(response)
            })
            .catch((error) => {
              window.responseError(error)
            })
        },
        function (data) {
          return service.enviarEmailDesistencia(desistencia, data)
        }
      )
    },
    informarNegativacao (desistencia) {
      this.$refs.emailView.open(
        function () {
          service.gerarEmailInformeNegativacao(desistencia)
            .then((response) => {
              this.bindLoad(response)
              console.log(response)
            })
            .catch((error) => {
              window.responseError(error)
            })
        },
        function (data) {
          return service.enviarEmailInformeNegativacao(desistencia, data)
        }
      )
    },
    negativar (desistencia) {
      this.$refs.emailView.open(
        function () {
          service.gerarEmailRegistroNegativacao(desistencia)
            .then((response) => {
              this.bindLoad(response)
              console.log(response)
            })
            .catch((error) => {
              window.responseError(error)
            })
        },
        function (data) {
          return service.enviarEmailRegistroNegativacao(desistencia, data)
        }
      )
    }
  }
}
</script>

<style scoped>
  td {
    color: #000000 !important;
  }

  .bg-dark {
    background-color: #ac2925;
    color: #FFFFFF;
  }

  .bg-black {
    background-color: #eed6d6 !important;
    color: #000000 !important;
  }

  a {
    color: #000000 !important;
  }
</style>



// WEBPACK FOOTER //
// Desistencias.vue?5411241f